"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FallbackNetNamingRule = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const NetNamingRules_1 = require("./NetNamingRules");
class FallbackNetNamingRule {
    constructor(defaultName) {
        this.defaultName = defaultName;
        this.type = NetNamingRules_1.NetNamingRuleType.Naming;
    }
    apply(group, _hierarchy) {
        const name = group.getLocalNames().sort((a, b) => sigma_engine_shared_1.Utils.naturalStringSort(a, b))[0];
        return name ?? this.defaultName;
    }
}
exports.FallbackNetNamingRule = FallbackNetNamingRule;
//# sourceMappingURL=FallbackNetNamingRule.js.map